"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var NaviItemCompanyController = /** @class */ (function (_super) {
    __extends(NaviItemCompanyController, _super);
    function NaviItemCompanyController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NaviItemCompanyController.prototype.showChildren = function () {
        this.childrenTarget.classList.remove('sharedHeaderNaviItemCompany-Children-closed');
    };
    NaviItemCompanyController.prototype.hideChildren = function () {
        this.childrenTarget.classList.add('sharedHeaderNaviItemCompany-Children-closed');
    };
    NaviItemCompanyController.targets = ['children'];
    return NaviItemCompanyController;
}(stimulus_1.Controller));
exports.default = NaviItemCompanyController;
